import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
    }

    handleGoHome = () => {
        window.location.href = '/';
    };

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="auth-page">
                    <div className="auth-card" style={{ textAlign: 'center', maxWidth: '480px' }}>
                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
                        
                        <h2 className="auth-title" style={{ fontSize: '24px', marginBottom: '12px' }}>
                            Something went wrong
                        </h2>
                        
                        <p className="auth-subtitle" style={{ marginBottom: '32px', lineHeight: '1.6' }}>
                            We're sorry for the inconvenience. The application encountered an unexpected error.
                        </p>
                        
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                            <button onClick={this.handleReload} className="btn-primary" style={{ flex: 1, minWidth: '140px' }}>
                                Reload Page
                            </button>
                            <button onClick={this.handleGoHome} className="btn-secondary" style={{ flex: 1, minWidth: '140px' }}>
                                Go Home
                            </button>
                        </div>

                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <details style={{ marginTop: '32px', textAlign: 'left', background: 'var(--bg-hover)', padding: '16px', borderRadius: 'var(--radius-md)', border: '1px solid var(--border)' }}>
                                <summary style={{ cursor: 'pointer', fontSize: '13px', color: 'var(--error)', fontWeight: '500' }}>
                                    Error details (dev only)
                                </summary>
                                <pre style={{ marginTop: '12px', fontSize: '11px', color: 'var(--text-secondary)', overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                    {this.state.error.toString()}
                                </pre>
                            </details>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;